module.exports = __webpack_public_path__ + "files/d865e7980af2239d3a89096d19312d9a.png";